import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Banner } from './SingleBanner2';
import BannerDesign2 from './BannerDesign2';

type Props = {
  banners: [Banner];
};

export default function BannerCarousel2({ banners }: Props) {
  return (
    <div className="swiper-container">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        speed={1000}
        loop={true}
        pagination={{
          el: '.banner-swiper-pagination',
          clickable: true,
        }}
        navigation={{
          nextEl: '.banner-swiper-button-next',
          prevEl: '.banner-swiper-button-prev',
        }}
        effect={'fade'}
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner.slug}>
            <BannerDesign2 banner={banner} />
          </SwiperSlide>
        ))}
        <div className="absolute flex items-center gap-x-4 z-10 left-4 top-84 md:left-4 md:top-132 lg:left-8 lg:top-132 xl:left-16 xl:top-164 -ml-1">
          <button
            aria-label="eelmine"
            className="swiper-button-prev banner-swiper-button-prev"
          />
          <div className="swiper-pagination banner-swiper-pagination invert!" />
          <button
            aria-label="järgmine"
            className="swiper-button-next banner-swiper-button-next"
          />
        </div>
      </Swiper>
    </div>
  );
}
